// extracted by mini-css-extract-plugin
export var active = "_2l-d";
export var blink = "_2l-e";
export var container = "_2l-5";
export var controls = "_2l-0";
export var controlsRight = "_2l-1";
export var fakeCursor = "_2l-c";
export var hidden = "_2l-b";
export var quillContainerSmall = "_2l-7";
export var quillEditor = "_2l-6";
export var quillEditorSmall = "_2l-8";
export var quillFormatButtons = "_2l-a";
export var quillToolbar = "_2l-9";
export var removePadding = "_2l-2";
export var state = "_2l-3";
export var stateTitle = "_2l-4";